import { createContext } from 'react'

export type DialogContextProps = {
    dialog?: object
    showDialog?(dialog: string): void
    hideDialog?(dialog: string): void
}

export const DialogContext = createContext<DialogContextProps>({})
